import { apiClient } from "@/api/api-client";
import ReactECharts from "echarts-for-react";
import React, { useRef, useState, useEffect } from "react";

const SampleDrilldownChart = () => {
  const chartRef = useRef<ReactECharts | null>(null);
  const [path, setPath] = useState([]);
  const defaultOption = {
    legend: {},
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    xAxis: {},
    yAxis: { type: "category", inverse: true },
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }, { type: "bar" }],
    dataset: {
      source: [
        ['status', 'Pending w/o Decision', 'Pending w/Decision', 'With Appeal', 'Case Closed']
      ],
    },
  };
  const [graphData, setGraphData] = useState(defaultOption);



  const defaultOption2 = {
    legend: {},
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },

    xAxis: {},
    yAxis: { type: "category", inverse: true },
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }],
  };

  const getCurrentNode = () => {
    let node = defaultOption.dataset.source;

    for (let idx of path) {
      if (Array.isArray(node)) {
        node = node[idx];
      } else {
        break;
      }
    }
    return node;
  };

  let currentNode = getCurrentNode();

  const goDeeper = (index) => {
    const nextNode = currentNode[index];
    console.log(nextNode);
    if (Array.isArray(nextNode)) {
      setPath([...path, index]);
    }
  };

  const handleDrilldown = (event) => {
    const instance = chartRef.current?.getEchartsInstance();

    const found = event.data.filter((element) => {
      if (Array.isArray(element)) {
        return element;
      }
    });

    if (found && found[0]) {
      goDeeper(event.dataIndex)

      instance.setOption({
        ...defaultOption2,
        dataset: {
          source: found[0],
        },
        graphic: [
          {
            type: "text",
            left: 5,
            bottom: 10,
            style: {
              text: "Back",
              fontSize: 14,
              // height: 34,
              fontWeight: "600",
              fill: "#fff",
              textVerticalAlign: "center",
              padding: [12, 12, 12, 12],
              borderRadius: 6,
              backgroundColor: "hsla(279, 42%, 45%)",
            },
            onclick: () => {
              goBack();
            },
          },
        ],
      });
    }
  };

  const goBack = () => {
    setPath(path.slice(0, -1));
  };


  const fetchData = async () => {
    const response = await apiClient.get('backoffice/sample-drilldown');
    setGraphData({
      ...defaultOption,
      dataset: {
        source:
          response.data,

      }
    });
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <ReactECharts
      ref={chartRef}
      option={graphData}
      onEvents={{ click: handleDrilldown }}
      style={{ height: "500px", width: "100%" }}
    />
  );
};

export default SampleDrilldownChart;
